function getRootDomain(hostname: string): string {
  const parts = hostname.split('.').filter(Boolean);
  return parts.length >= 2 ? parts.slice(-2).join('.') : hostname;
}

export function getSupportUrl(): string {
  const configuredUrl = process.env.REACT_APP_SUPPORT_URL?.trim().replace(/\/+$/, '');
  if (configuredUrl) return configuredUrl;

  const { hostname, protocol } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1')
    return 'http://localhost:3004';

  return `${protocol}//support.${getRootDomain(hostname)}`;
}

export const supportUrl = getSupportUrl();
export const supportProject = process.env.REACT_APP_SUPPORT_PROJECT || 'buysbp';
